import React from "react";
import { ErrorMatchers, UploadModel } from "../Types/uploadAppModal"
import { Link } from "@amzn/awsui-components-console";

export const UploadAppModalText = {
    IncorrectFileType: "Only JSON Files are accepted.",
    FileTypeDefinition: "Only JSON Files will be accepted.",
    MissingFields: (str:string) => `Uploaded File is missing the following fields: ${str}`,
    Title: "Upload App",
    UploadButton: "Upload App",
    CancelButton: "Cancel",
    ChooseFile: "Choose file",
    ErrorAria: "Error",
    UploadComplete: "App Upload Complete!",
    RedirectNotice: (url: string):React.JSX.Element => (<>You will be directed to the App's Details page shortly. Click <Link href={url}>here</Link> to go now.</>),
    RedirectLinkText: "here",
    AppPreviewTitle: "App to Upload",
    ChooseDifferentFile: "Upload a Different File",
    AppNameExists: (appName: string) => `App Name: "${appName}" already exists. Change it in order to upload.`,
    ProcessPreviewTitle: "Processes to Upload",
    NoProcesses: "None To Upload",
    AppUploadProgressTitle: "Uploading App Progress",
    ProcessUploadProgressTitle: "Uploading Processes Progress",
}

export const SECONDARY_DETAILS = [
  "tanc", "ripples"
]

export const DefaultUploadModel: UploadModel = {
  app: {
    creating: false,
    created: false,
  },
  processes: {
    "frisco": [],
    "logico": [],
    "flexico": [],
  },
  creating: false,
}

export const JSON_FILE_TYPE = 'application/json'

export const ERROR_MATCHERS: ErrorMatchers = {
  "Key (team, business, dataset_name)": {
    input: "dataset_name",
    displayError: "Dataset name is a duplicate. Please update and retry upload."
  },
  "Key (process_name)": {
    input: "process_name",
    displayError: "Process name is a duplicate. Please update and retry upload."
  },
  "more than one row returned by a subquery used as an expression": {
    input: "template_name",
    displayError: "Template name is a duplicate. Please update and retry upload."
  }
}

export const DefaultProcessModel = {
    creating: false,
    created: false,
    processData: {}
}

export const REDIRECT_WAIT_TIME = 5000;